export const API_ROOT =
  process.env.REACT_APP_API_ROOT || 'https://kb.digilabs.ca/';
export const TINY_MCE_PATH =
  process.env.REACT_APP_TINY_MCE_PATH ||
  'https://nyc3.digitaloceanspaces.com/digilabs/lawvo/tinymce/tinymce.min.js';
